/* SCALR Theme · Interaktionen (ohne Bibliotheken) */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Galerie: Vorschaubilder tauschen das Hauptbild */
  function showMedia(gal, btn) {
    var main = $('.gal-main img', gal);
    if (!main || !btn) return;
    main.src = btn.dataset.src; main.removeAttribute('srcset'); main.alt = btn.dataset.alt || '';
    $$('.gal-th button', gal).forEach(function (x) { x.setAttribute('aria-current', x === btn ? 'true' : 'false'); });
  }
  $$('[data-pgal]').forEach(function (g) {
    $$('.gal-th button', g).forEach(function (b) { b.addEventListener('click', function () { showMedia(g, b); }); });
  });

  /* Varianten: Auswahl → passende Variante, Preis, Bild, Verfügbarkeit */
  $$('[data-product-section]').forEach(function (sec) {
    var id = sec.dataset.productSection;
    var data = $('script[data-variants="' + id + '"]');
    var form = $('form[id="pf-' + id + '"]');
    if (!data || !form) return;
    var variants = []; try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var input = $('[data-variant-id]', form), atc = $('[data-atc]', form);
    var sticky = $('[data-sticky="atc-' + id + '"]');
    function current() {
      return $$('.opt', form).map(function (fs) {
        var sel = $('select', fs); if (sel) return sel.value;
        var r = $('input:checked', fs); return r ? r.value : null;
      });
    }
    function update() {
      var opts = current();
      $$('.opt', form).forEach(function (fs, i) { var l = $('[data-opt-label]', fs); if (l) l.textContent = opts[i]; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      // Knöpfe ohne verfügbare Variante grau machen
      $$('.opt', form).forEach(function (fs, i) {
        $$('.pills label', fs).forEach(function (lab) {
          var val = $('input', lab).value;
          var ok = variants.some(function (x) { return x.available && x.options[i] === val && x.options.every(function (o, j) { return j === i || o === opts[j]; }); });
          lab.classList.toggle('na', !ok);
        });
      });
      if (!v) { atc.disabled = true; atc.textContent = 'Nicht verfügbar'; return; }
      input.value = v.id;
      $$('[data-price]', sec.parentNode).forEach(function (el) { if (el.closest('[data-product-section]') === sec || el.closest('[data-sticky]') === sticky) el.textContent = v.price; });
      var cmp = $('[data-compare]', sec), save = $('[data-save]', sec);
      if (cmp) { cmp.hidden = !v.compare; if (v.compare) cmp.textContent = v.compare; }
      if (save) { save.hidden = !v.save; save.textContent = '−' + v.save + ' %'; }
      var unit = $('[data-unit]', sec);
      if (unit) { unit.hidden = !v.unit; if (v.unit) $('[data-unit-val]', unit).textContent = v.unit; }
      var st = $('[data-stock]', sec);
      if (st) { st.classList.toggle('out', !v.available); $('[data-stock-in]', st).hidden = !v.available; $('[data-stock-out]', st).hidden = v.available; }
      atc.disabled = !v.available;
      atc.textContent = v.available ? atc.dataset.label : 'Ausverkauft';
      if (v.media) { var b = $('.gal-th button[data-media="' + v.media + '"]', sec); if (b) showMedia($('[data-pgal]', sec), b); }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    form.addEventListener('change', function (e) { if (e.target.closest('.opt')) update(); });
  });

  /* Mengen-Knöpfe (Produkt + Warenkorb) */
  $$('[data-qty]').forEach(function (q) {
    var inp = $('input', q);
    $$('[data-step]', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var min = parseInt(inp.min || '1', 10);
        inp.value = Math.max(min, (parseInt(inp.value, 10) || 0) + parseInt(b.dataset.step, 10));
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
  var cartForm = $('#cart-form'), cartTimer;
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-autoupdate]')) return;
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () {
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = '1';
        cartForm.appendChild(h); cartForm.submit();
      }, 450);
    });
  }

  /* Pflicht-Haken: roter Rahmen, falls vergessen */
  $$('[data-consent]').forEach(function (c) {
    c.addEventListener('invalid', function () { c.closest('.consent').classList.add('err'); });
    c.addEventListener('change', function () { c.closest('.consent').classList.toggle('err', !c.checked); });
  });

  /* Slider-Pfeile */
  $$('[data-slider]').forEach(function (s) {
    var t = $('.track', s);
    $$('[data-dir]', s).forEach(function (b) {
      b.addEventListener('click', function () {
        var card = t.firstElementChild; var w = card ? card.getBoundingClientRect().width + 16 : 300;
        t.scrollBy({ left: (b.dataset.dir === 'next' ? 1 : -1) * w, behavior: 'smooth' });
      });
    });
  });

  /* Tabs */
  $$('[data-tabs]').forEach(function (box) {
    var btns = $$('[role=tab]', box), imgs = $$('[data-tabimg]', box);
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, j) {
          x.setAttribute('aria-selected', j === i ? 'true' : 'false');
          var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = (j !== i);
          if (imgs[j]) imgs[j].hidden = (j !== i);
        });
      });
    });
  });

  /* Foto-Wand aufklappen */
  $$('[data-wallmore]').forEach(function (b) {
    b.addEventListener('click', function () {
      var w = document.getElementById(b.dataset.wallmore); if (!w) return;
      w.classList.add('open'); b.parentElement.hidden = true;
    });
  });

  /* YouTube erst nach Klick laden (youtube-nocookie) */
  $$('[data-video-section]').forEach(function (root) {
    var box = $('[data-yt]', root); if (!box) return;
    var id = box.getAttribute('data-yt'); if (!id) return;
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-t]'); if (!b || !root.contains(b)) return;
      var t = parseInt(b.getAttribute('data-t'), 10) || 0;
      box.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1&start=' + t + '" title="Video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      if (b.closest('.pcase-chap')) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* Sticky-Kaufleiste, sobald der Haupt-Button aus dem Bild ist */
  $$('[data-sticky]').forEach(function (st) {
    var atc = document.getElementById(st.dataset.sticky);
    if (!atc || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      var below = e[0].boundingClientRect.top < 0;
      st.classList.toggle('on', !e[0].isIntersecting && below);
      st.setAttribute('aria-hidden', st.classList.contains('on') ? 'false' : 'true');
    }).observe(atc);
  });

  /* Handy-Menü */
  $$('[data-drawer]').forEach(function (d) {
    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]') || e.target.classList.contains('drawer')) { e.preventDefault(); d.removeAttribute('open'); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') d.removeAttribute('open'); });
  });

  /* Suche in der Kopfzeile aufklappen */
  var st = $('[data-search-toggle]'), box = $('#hdr-search');
  if (st && box) st.addEventListener('click', function (e) {
    e.preventDefault(); box.hidden = !box.hidden; if (!box.hidden) $('input[type=search]', box).focus();
  });


  /* Warenkorb-Einschub (wie WoofTag): Hinzufügen ohne Neuladen, Einschub öffnet sich */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawerOn = document.body.getAttribute('data-cart-type') === 'drawer';
  function cd() { return document.getElementById('cart-drawer'); }
  function openCart() {
    var d = cd(); if (!d) return false;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cd-lock');
    var p = $('.cd-panel', d); if (p) p.focus();
    return true;
  }
  function closeCart() {
    var d = cd(); if (!d) return;
    d.classList.remove('open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-lock');
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
  }
  function refreshCart(open) {
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('.cd-panel'), d = cd();
        if (fresh && d) $('.cd-panel', d).innerHTML = fresh.innerHTML;
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (c) { setCount(c.item_count); if (open) openCart(); });
  }
  if (drawerOn && cd()) {
    $$('form[id^="pf-"]').forEach(function (form) {
      if ($('input[name="return_to"]', form)) return; // "Direkt zur Kasse" bleibt normales Absenden
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.reportValidity()) return;
        var btns = $$('[data-atc], [data-atc-sticky]').filter(function (b) { return b.form === form; });
        btns.forEach(function (b) { b.disabled = true; b.classList.add('loading'); });
        var err = $('.atc-err', form); if (err) err.remove();
        fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return refreshCart(true); })
          .catch(function (j) {
            var m = document.createElement('p'); m.className = 'form-msg err atc-err'; m.style.marginTop = '10px';
            m.textContent = (j && (j.description || j.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
            var row = $('.buyrow', form); (row || form).insertAdjacentElement('afterend', m);
          })
          .then(function () { btns.forEach(function (b) { b.classList.remove('loading'); b.disabled = false; }); });
      });
    });
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { if (openCart()) e.preventDefault(); });
    });
    document.addEventListener('click', function (e) {
      var d = cd(); if (!d || !d.contains(e.target)) return;
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      var b = e.target.closest('[data-line]'); if (!b) return;
      b.disabled = true; d.classList.add('busy');
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ line: parseInt(b.dataset.line, 10), quantity: Math.max(0, parseInt(b.dataset.q, 10)) }) })
        .then(function () { return refreshCart(false); })
        .then(function () { d.classList.remove('busy'); }, function () { d.classList.remove('busy'); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  }

  /* Sortierung sofort anwenden */
  $$('[data-autosubmit] select').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });
})();
